export default __webpack_public_path__ + "8101be9d10bf094e8121ca0df8a19f08.svg";